module.exports = __webpack_public_path__ + "static/media/vivo.c2f23ac0.png";